import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

/**
 * Componente para convertir un icono de FontAwesome a base64 con fondo circular
 */
const IconToBase64 = ({ onGenerated, size = 100 }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!containerRef.current) return;

        setTimeout(() => {
            const svg = containerRef.current.querySelector('svg');
            if (!svg) {
                console.error('No se encontró el SVG del icono');
                return;
            }

            try {
                // Crear canvas
                const canvas = document.createElement('canvas');
                canvas.width = size;
                canvas.height = size;
                const ctx = canvas.getContext('2d');
                
                // Dibujar círculo blanco de fondo
                ctx.fillStyle = '#ffffff';
                ctx.beginPath();
                ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
                ctx.fill();
                
                // Clonar el SVG para modificarlo
                const clonedSvg = svg.cloneNode(true);
                
                // Establecer dimensiones (80% del tamaño para dejar margen)
                const iconSize = size * 0.8;
                clonedSvg.setAttribute('width', iconSize);
                clonedSvg.setAttribute('height', iconSize);
                
                // Cambiar el color a verde de WhatsApp
                clonedSvg.setAttribute('fill', '#25D366');
                
                // Serializar el SVG
                const svgData = new XMLSerializer().serializeToString(clonedSvg);
                
                // Crear imagen del icono
                const img = new Image();
                
                img.onload = () => {
                    // Dibujar el icono centrado sobre el círculo blanco
                    const offset = (size - iconSize) / 2;
                    ctx.drawImage(img, offset, offset, iconSize, iconSize);
                    
                    // Convertir a PNG base64
                    const pngData = canvas.toDataURL('image/png');
                    onGenerated(pngData);
                };

                img.onerror = (err) => {
                    console.error('Error generando imagen del icono:', err);
                };

                // Convertir SVG a data URL
                const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
                const url = URL.createObjectURL(svgBlob);
                img.src = url;
            } catch (error) {
                console.error('Error en IconToBase64:', error);
            }
        }, 100);
    }, [size, onGenerated]);

    return (
        <div ref={containerRef} style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
            <FontAwesomeIcon 
                icon={faWhatsapp} 
                style={{ 
                    fontSize: `${size}px`,
                    color: '#25D366'
                }} 
            />
        </div>
    );
};

export default IconToBase64;
